<template>
	<div class="popup-tip" v-show="msgControl">
		<slot name="content">提示</slot>
	</div>
</template>
<script>
	export default {
		props: {
			msgControl: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
			}
		}
	}
</script>
<style>
	.popup-tip{
		position: fixed;
		bottom: 2rem;
		left: 50%;
		transform: translateX(-50%);
		z-index: 9999;
		background: #fff;
		padding: .1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/tip.vue